import * as dateFns from 'date-fns'
import React from 'react'

import { shortFormatNumber } from '../../util'
import { EARNINGS_DATE_FORMAT } from './constants'

interface Props {
  downRevisions: number
  estimate: number
  label: string
  revisionDate: Date
  revisions: number
  upRevisions: number
}

export default function LatestRevision({
  downRevisions,
  estimate,
  label,
  revisionDate,
  revisions,
  upRevisions,
}: Props) {
  return (
    <div className="grid flex-1 grid-cols-[102px_auto] pl-1.5 pr-1.5 text-2xs text-muted-2">
      <div className="col-span-2 text-muted">{label}</div>
      <div>Estimate</div>
      <div className="text-default">{shortFormatNumber(estimate)}</div>
      <div>Up Revisions</div>
      <div>
        <span className="text-success-1">{upRevisions}</span>/{revisions}
      </div>
      <div>Down Revisions</div>
      <div>
        <span className="text-danger-1">{downRevisions}</span>/{revisions}
      </div>
      <div>Revision Date</div>
      <div className="text-default">{dateFns.format(revisionDate, EARNINGS_DATE_FORMAT)}</div>
    </div>
  )
}
